import { apiCall } from '.';
import { LoanDto, LoanOfferDto, LoanQueryParams, UpdateLoanOfferDto, UpdateLoanOfferStatusDto } from '../interfaces';

export const submitLoanApplication = (payload: LoanDto) => {
  return apiCall(true).post('/loans', payload);
};

export const fetchLoansApi = (params: LoanQueryParams) => {
  return apiCall(true).get('/loans', { params });
};

export const getSingleLoan = (id: number) => {
  return apiCall(true).get(`loans/${id}`);
};

export const getLoanOffers = (id: number) => {
  return apiCall(true).get(`loans/${id}/offers`);
};

export const submitLoanOffer = (payload: LoanOfferDto) => {
  return apiCall(true).post(`loan-offers`, payload);
};

export const updateLoanOfferStatusApi = (payload: UpdateLoanOfferStatusDto, offerId: number) => {
  return apiCall(true).patch(`loan-offers/${offerId}/status`, payload);
};

export const updateLoanOfferApi = (payload: UpdateLoanOfferDto, offerId: number) => {
  return apiCall(true).patch(`loan-offers/${offerId}`, payload);
};

export const getLoanRepaymentInfoApi = (id: number) => {
  return apiCall(true).get(`loans/${id}/repayments`)
}

export const getLoanTransactionApi = (id: number) => {
  return apiCall(true).get(`loans/${id}/transactions`)
}
